.wizards-wizard {
  display: inline-block;
  margin: 10px;
  padding: 10px;
  border: solid 1px #ccc;
}

button {
  cursor: pointer;
  margin: 5px;
}

h2 {
  text-align: center;
}

